module.exports = __webpack_public_path__ + "img/my_active_icon@2x.a86720da.png";